/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * CourtListener REST API
 * The CourtListener REST API provides access to a comprehensive database of legal documents, case law, judges, oral arguments, and citation lookups. This API supports advanced search capabilities, rate limiting, and token-based authentication.
 * OpenAPI spec version: 4.0.0
 */
import type {
  Agreement,
  Alert,
  Audio,
  Citation,
  CitationResult,
  Cluster,
  Court,
  Debt,
  Docket,
  DocketAlert,
  FinancialDisclosure,
  Get200,
  GetAgreementsParams,
  GetAlertsParams,
  GetAudioParams,
  GetCitationsParams,
  GetClustersParams,
  GetCourtsParams,
  GetDebtsParams,
  GetDocketAlertsParams,
  GetDocketsParams,
  GetFinancialDisclosuresParams,
  GetGiftsParams,
  GetInvestmentsParams,
  GetJudgePositionsParams,
  GetNonInvestmentIncomeParams,
  GetOpinionsParams,
  GetOriginalProceedingsPanelsParams,
  GetPacerDocIdsParams,
  GetPeopleParams,
  GetPoliticalAffiliationsParams,
  GetPositionsParams,
  GetProcessingQueueParams,
  GetRecapParams,
  GetReimbursementsParams,
  GetSchoolsParams,
  GetSearchParams,
  GetSpouseIncomeParams,
  GetVisualizationsParams,
  Gift,
  Investment,
  JudgePosition,
  NonInvestmentIncome,
  Opinion,
  PaginatedAgreements,
  PaginatedAlerts,
  PaginatedAudio,
  PaginatedCitations,
  PaginatedClusters,
  PaginatedCourts,
  PaginatedDebts,
  PaginatedDocketAlerts,
  PaginatedDockets,
  PaginatedFinancialDisclosures,
  PaginatedGifts,
  PaginatedInvestments,
  PaginatedJudgePositions,
  PaginatedNonInvestmentIncome,
  PaginatedOpinions,
  PaginatedOriginalProceedingsPanels,
  PaginatedPACERDocIDs,
  PaginatedPeople,
  PaginatedPoliticalAffiliations,
  PaginatedPositions,
  PaginatedProcessingQueue,
  PaginatedRECAPDocuments,
  PaginatedReimbursements,
  PaginatedSchools,
  PaginatedSpouseIncome,
  PaginatedVisualizations,
  Person,
  PoliticalAffiliation,
  Position,
  PostAlertsBody,
  PostCitationLookupBody,
  PostDocketAlertsBody,
  PostRecapFetchBody,
  RECAPDocument,
  RECAPFetchResponse,
  Reimbursement,
  School,
  SearchResults,
  SpouseIncome,
  Visualization
} from './model';

import { customInstance } from '../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Returns a JSON object with all available API endpoints and their descriptions
 * @summary Get API root endpoints
 */
export const get = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Get200>(
      {url: `https://www.courtlistener.com/api/rest/v4/`, method: 'GET'
    },
      options);
    }
  
/**
 * Search across all content types including opinions, oral arguments, people, and RECAP documents. Supports advanced query operators including AND, OR, NOT, quotes, wildcards, fuzzy search (~), and field-specific searches.
 * @summary Universal search
 */
export const getSearch = (
    params?: GetSearchParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<SearchResults>(
      {url: `https://www.courtlistener.com/api/rest/v4/search/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Look up citations by providing either a text blob containing citations or specific volume/reporter/page parameters. Rate limited to 60 citations per minute with a maximum of 250 citations per request.
 * @summary Citation lookup and normalization
 */
export const postCitationLookup = (
    postCitationLookupBody: PostCitationLookupBody,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<CitationResult>(
      {url: `https://www.courtlistener.com/api/rest/v4/citation-lookup/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCitationLookupBody
    },
      options);
    }
  
/**
 * Get a list of court dockets with case information
 * @summary List dockets
 */
export const getDockets = (
    params?: GetDocketsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedDockets>(
      {url: `https://www.courtlistener.com/api/rest/v4/dockets/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific docket
 * @summary Get docket by ID
 */
export const getDocketsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Docket>(
      {url: `https://www.courtlistener.com/api/rest/v4/dockets/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of opinion clusters (groups of related opinions)
 * @summary List opinion clusters
 */
export const getClusters = (
    params?: GetClustersParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedClusters>(
      {url: `https://www.courtlistener.com/api/rest/v4/clusters/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific opinion cluster
 * @summary Get cluster by ID
 */
export const getClustersId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Cluster>(
      {url: `https://www.courtlistener.com/api/rest/v4/clusters/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of legal opinions
 * @summary List opinions
 */
export const getOpinions = (
    params?: GetOpinionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedOpinions>(
      {url: `https://www.courtlistener.com/api/rest/v4/opinions/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific legal opinion
 * @summary Get opinion by ID
 */
export const getOpinionsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Opinion>(
      {url: `https://www.courtlistener.com/api/rest/v4/opinions/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of all courts in the system
 * @summary List courts
 */
export const getCourts = (
    params?: GetCourtsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedCourts>(
      {url: `https://www.courtlistener.com/api/rest/v4/courts/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific court
 * @summary Get court by ID
 */
export const getCourtsId = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Court>(
      {url: `https://www.courtlistener.com/api/rest/v4/courts/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judges and other legal professionals
 * @summary List people (judges)
 */
export const getPeople = (
    params?: GetPeopleParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedPeople>(
      {url: `https://www.courtlistener.com/api/rest/v4/people/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific judge or legal professional
 * @summary Get person by ID
 */
export const getPeopleId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Person>(
      {url: `https://www.courtlistener.com/api/rest/v4/people/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of oral argument audio recordings
 * @summary List oral argument recordings
 */
export const getAudio = (
    params?: GetAudioParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedAudio>(
      {url: `https://www.courtlistener.com/api/rest/v4/audio/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific oral argument recording
 * @summary Get audio recording by ID
 */
export const getAudioId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Audio>(
      {url: `https://www.courtlistener.com/api/rest/v4/audio/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge financial disclosures
 * @summary List financial disclosures
 */
export const getFinancialDisclosures = (
    params?: GetFinancialDisclosuresParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedFinancialDisclosures>(
      {url: `https://www.courtlistener.com/api/rest/v4/financial-disclosures/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific financial disclosure
 * @summary Get financial disclosure by ID
 */
export const getFinancialDisclosuresId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<FinancialDisclosure>(
      {url: `https://www.courtlistener.com/api/rest/v4/financial-disclosures/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge investments from financial disclosures
 * @summary List investments
 */
export const getInvestments = (
    params?: GetInvestmentsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedInvestments>(
      {url: `https://www.courtlistener.com/api/rest/v4/investments/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific investment
 * @summary Get investment by ID
 */
export const getInvestmentsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Investment>(
      {url: `https://www.courtlistener.com/api/rest/v4/investments/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge positions from financial disclosures
 * @summary List positions
 */
export const getPositions = (
    params?: GetPositionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedPositions>(
      {url: `https://www.courtlistener.com/api/rest/v4/positions/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific position
 * @summary Get position by ID
 */
export const getPositionsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Position>(
      {url: `https://www.courtlistener.com/api/rest/v4/positions/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge agreements from financial disclosures
 * @summary List agreements
 */
export const getAgreements = (
    params?: GetAgreementsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedAgreements>(
      {url: `https://www.courtlistener.com/api/rest/v4/agreements/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific agreement
 * @summary Get agreement by ID
 */
export const getAgreementsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Agreement>(
      {url: `https://www.courtlistener.com/api/rest/v4/agreements/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge non-investment income from financial disclosures
 * @summary List non-investment income
 */
export const getNonInvestmentIncome = (
    params?: GetNonInvestmentIncomeParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedNonInvestmentIncome>(
      {url: `https://www.courtlistener.com/api/rest/v4/non-investment-income/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about specific non-investment income
 * @summary Get non-investment income by ID
 */
export const getNonInvestmentIncomeId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<NonInvestmentIncome>(
      {url: `https://www.courtlistener.com/api/rest/v4/non-investment-income/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge spouse income from financial disclosures
 * @summary List spouse income
 */
export const getSpouseIncome = (
    params?: GetSpouseIncomeParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedSpouseIncome>(
      {url: `https://www.courtlistener.com/api/rest/v4/spouse-income/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about specific spouse income
 * @summary Get spouse income by ID
 */
export const getSpouseIncomeId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<SpouseIncome>(
      {url: `https://www.courtlistener.com/api/rest/v4/spouse-income/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge reimbursements from financial disclosures
 * @summary List reimbursements
 */
export const getReimbursements = (
    params?: GetReimbursementsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedReimbursements>(
      {url: `https://www.courtlistener.com/api/rest/v4/reimbursements/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific reimbursement
 * @summary Get reimbursement by ID
 */
export const getReimbursementsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Reimbursement>(
      {url: `https://www.courtlistener.com/api/rest/v4/reimbursements/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge gifts from financial disclosures
 * @summary List gifts
 */
export const getGifts = (
    params?: GetGiftsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedGifts>(
      {url: `https://www.courtlistener.com/api/rest/v4/gifts/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific gift
 * @summary Get gift by ID
 */
export const getGiftsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Gift>(
      {url: `https://www.courtlistener.com/api/rest/v4/gifts/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge debts from financial disclosures
 * @summary List debts
 */
export const getDebts = (
    params?: GetDebtsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedDebts>(
      {url: `https://www.courtlistener.com/api/rest/v4/debts/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific debt
 * @summary Get debt by ID
 */
export const getDebtsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Debt>(
      {url: `https://www.courtlistener.com/api/rest/v4/debts/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get user's search alerts
 * @summary List search alerts
 */
export const getAlerts = (
    params?: GetAlertsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedAlerts>(
      {url: `https://www.courtlistener.com/api/rest/v4/alerts/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Create a new search alert
 * @summary Create search alert
 */
export const postAlerts = (
    postAlertsBody: PostAlertsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Alert>(
      {url: `https://www.courtlistener.com/api/rest/v4/alerts/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAlertsBody
    },
      options);
    }
  
/**
 * Get list of PACER documents in processing queue
 * @summary List PACER processing queue items
 */
export const getProcessingQueue = (
    params?: GetProcessingQueueParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedProcessingQueue>(
      {url: `https://www.courtlistener.com/api/rest/v4/processing-queue/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Get list of RECAP documents from PACER
 * @summary List RECAP documents
 */
export const getRecap = (
    params?: GetRecapParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedRECAPDocuments>(
      {url: `https://www.courtlistener.com/api/rest/v4/recap/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific RECAP document
 * @summary Get RECAP document by ID
 */
export const getRecapId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RECAPDocument>(
      {url: `https://www.courtlistener.com/api/rest/v4/recap/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get list of PACER document identifiers
 * @summary List PACER document IDs
 */
export const getPacerDocIds = (
    params?: GetPacerDocIdsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedPACERDocIDs>(
      {url: `https://www.courtlistener.com/api/rest/v4/pacer-doc-ids/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Fetch a specific document from PACER via RECAP
 * @summary Fetch RECAP document
 */
export const postRecapFetch = (
    postRecapFetchBody: PostRecapFetchBody,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RECAPFetchResponse>(
      {url: `https://www.courtlistener.com/api/rest/v4/recap-fetch/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRecapFetchBody
    },
      options);
    }
  
/**
 * Get user's docket alerts for case updates
 * @summary List docket alerts
 */
export const getDocketAlerts = (
    params?: GetDocketAlertsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedDocketAlerts>(
      {url: `https://www.courtlistener.com/api/rest/v4/docket-alerts/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Create a new docket alert for case updates
 * @summary Create docket alert
 */
export const postDocketAlerts = (
    postDocketAlertsBody: PostDocketAlertsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<DocketAlert>(
      {url: `https://www.courtlistener.com/api/rest/v4/docket-alerts/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postDocketAlertsBody
    },
      options);
    }
  
/**
 * Get list of original proceedings panels from PACER
 * @summary List original proceedings panels
 */
export const getOriginalProceedingsPanels = (
    params?: GetOriginalProceedingsPanelsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedOriginalProceedingsPanels>(
      {url: `https://www.courtlistener.com/api/rest/v4/original-proceedings-panels/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Get a list of judicial positions
 * @summary List judge positions
 */
export const getJudgePositions = (
    params?: GetJudgePositionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedJudgePositions>(
      {url: `https://www.courtlistener.com/api/rest/v4/judge-positions/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific judicial position
 * @summary Get judge position by ID
 */
export const getJudgePositionsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<JudgePosition>(
      {url: `https://www.courtlistener.com/api/rest/v4/judge-positions/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of schools from judge education data
 * @summary List schools
 */
export const getSchools = (
    params?: GetSchoolsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedSchools>(
      {url: `https://www.courtlistener.com/api/rest/v4/schools/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific school
 * @summary Get school by ID
 */
export const getSchoolsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<School>(
      {url: `https://www.courtlistener.com/api/rest/v4/schools/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get a list of judge political affiliations
 * @summary List political affiliations
 */
export const getPoliticalAffiliations = (
    params?: GetPoliticalAffiliationsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedPoliticalAffiliations>(
      {url: `https://www.courtlistener.com/api/rest/v4/political-affiliations/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific political affiliation
 * @summary Get political affiliation by ID
 */
export const getPoliticalAffiliationsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PoliticalAffiliation>(
      {url: `https://www.courtlistener.com/api/rest/v4/political-affiliations/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get citation network information showing how cases cite each other
 * @summary List citation network data
 */
export const getCitations = (
    params?: GetCitationsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedCitations>(
      {url: `https://www.courtlistener.com/api/rest/v4/citations/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific citation relationship
 * @summary Get citation by ID
 */
export const getCitationsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Citation>(
      {url: `https://www.courtlistener.com/api/rest/v4/citations/${id}/`, method: 'GET'
    },
      options);
    }
  
/**
 * Get data for network visualizations and charts
 * @summary List visualization data
 */
export const getVisualizations = (
    params?: GetVisualizationsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<PaginatedVisualizations>(
      {url: `https://www.courtlistener.com/api/rest/v4/visualizations/`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Retrieve detailed information about a specific visualization
 * @summary Get visualization by ID
 */
export const getVisualizationsId = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Visualization>(
      {url: `https://www.courtlistener.com/api/rest/v4/visualizations/${id}/`, method: 'GET'
    },
      options);
    }
  
export type GetResult = NonNullable<Awaited<ReturnType<typeof get>>>
export type GetSearchResult = NonNullable<Awaited<ReturnType<typeof getSearch>>>
export type PostCitationLookupResult = NonNullable<Awaited<ReturnType<typeof postCitationLookup>>>
export type GetDocketsResult = NonNullable<Awaited<ReturnType<typeof getDockets>>>
export type GetDocketsIdResult = NonNullable<Awaited<ReturnType<typeof getDocketsId>>>
export type GetClustersResult = NonNullable<Awaited<ReturnType<typeof getClusters>>>
export type GetClustersIdResult = NonNullable<Awaited<ReturnType<typeof getClustersId>>>
export type GetOpinionsResult = NonNullable<Awaited<ReturnType<typeof getOpinions>>>
export type GetOpinionsIdResult = NonNullable<Awaited<ReturnType<typeof getOpinionsId>>>
export type GetCourtsResult = NonNullable<Awaited<ReturnType<typeof getCourts>>>
export type GetCourtsIdResult = NonNullable<Awaited<ReturnType<typeof getCourtsId>>>
export type GetPeopleResult = NonNullable<Awaited<ReturnType<typeof getPeople>>>
export type GetPeopleIdResult = NonNullable<Awaited<ReturnType<typeof getPeopleId>>>
export type GetAudioResult = NonNullable<Awaited<ReturnType<typeof getAudio>>>
export type GetAudioIdResult = NonNullable<Awaited<ReturnType<typeof getAudioId>>>
export type GetFinancialDisclosuresResult = NonNullable<Awaited<ReturnType<typeof getFinancialDisclosures>>>
export type GetFinancialDisclosuresIdResult = NonNullable<Awaited<ReturnType<typeof getFinancialDisclosuresId>>>
export type GetInvestmentsResult = NonNullable<Awaited<ReturnType<typeof getInvestments>>>
export type GetInvestmentsIdResult = NonNullable<Awaited<ReturnType<typeof getInvestmentsId>>>
export type GetPositionsResult = NonNullable<Awaited<ReturnType<typeof getPositions>>>
export type GetPositionsIdResult = NonNullable<Awaited<ReturnType<typeof getPositionsId>>>
export type GetAgreementsResult = NonNullable<Awaited<ReturnType<typeof getAgreements>>>
export type GetAgreementsIdResult = NonNullable<Awaited<ReturnType<typeof getAgreementsId>>>
export type GetNonInvestmentIncomeResult = NonNullable<Awaited<ReturnType<typeof getNonInvestmentIncome>>>
export type GetNonInvestmentIncomeIdResult = NonNullable<Awaited<ReturnType<typeof getNonInvestmentIncomeId>>>
export type GetSpouseIncomeResult = NonNullable<Awaited<ReturnType<typeof getSpouseIncome>>>
export type GetSpouseIncomeIdResult = NonNullable<Awaited<ReturnType<typeof getSpouseIncomeId>>>
export type GetReimbursementsResult = NonNullable<Awaited<ReturnType<typeof getReimbursements>>>
export type GetReimbursementsIdResult = NonNullable<Awaited<ReturnType<typeof getReimbursementsId>>>
export type GetGiftsResult = NonNullable<Awaited<ReturnType<typeof getGifts>>>
export type GetGiftsIdResult = NonNullable<Awaited<ReturnType<typeof getGiftsId>>>
export type GetDebtsResult = NonNullable<Awaited<ReturnType<typeof getDebts>>>
export type GetDebtsIdResult = NonNullable<Awaited<ReturnType<typeof getDebtsId>>>
export type GetAlertsResult = NonNullable<Awaited<ReturnType<typeof getAlerts>>>
export type PostAlertsResult = NonNullable<Awaited<ReturnType<typeof postAlerts>>>
export type GetProcessingQueueResult = NonNullable<Awaited<ReturnType<typeof getProcessingQueue>>>
export type GetRecapResult = NonNullable<Awaited<ReturnType<typeof getRecap>>>
export type GetRecapIdResult = NonNullable<Awaited<ReturnType<typeof getRecapId>>>
export type GetPacerDocIdsResult = NonNullable<Awaited<ReturnType<typeof getPacerDocIds>>>
export type PostRecapFetchResult = NonNullable<Awaited<ReturnType<typeof postRecapFetch>>>
export type GetDocketAlertsResult = NonNullable<Awaited<ReturnType<typeof getDocketAlerts>>>
export type PostDocketAlertsResult = NonNullable<Awaited<ReturnType<typeof postDocketAlerts>>>
export type GetOriginalProceedingsPanelsResult = NonNullable<Awaited<ReturnType<typeof getOriginalProceedingsPanels>>>
export type GetJudgePositionsResult = NonNullable<Awaited<ReturnType<typeof getJudgePositions>>>
export type GetJudgePositionsIdResult = NonNullable<Awaited<ReturnType<typeof getJudgePositionsId>>>
export type GetSchoolsResult = NonNullable<Awaited<ReturnType<typeof getSchools>>>
export type GetSchoolsIdResult = NonNullable<Awaited<ReturnType<typeof getSchoolsId>>>
export type GetPoliticalAffiliationsResult = NonNullable<Awaited<ReturnType<typeof getPoliticalAffiliations>>>
export type GetPoliticalAffiliationsIdResult = NonNullable<Awaited<ReturnType<typeof getPoliticalAffiliationsId>>>
export type GetCitationsResult = NonNullable<Awaited<ReturnType<typeof getCitations>>>
export type GetCitationsIdResult = NonNullable<Awaited<ReturnType<typeof getCitationsId>>>
export type GetVisualizationsResult = NonNullable<Awaited<ReturnType<typeof getVisualizations>>>
export type GetVisualizationsIdResult = NonNullable<Awaited<ReturnType<typeof getVisualizationsId>>>
